'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMCheckbox = function WMCheckbox(_ref) {
	var labelStyle = _ref.labelStyle,
	    style = _ref.style,
	    checked = _ref.checked,
	    disabled = _ref.disabled,
	    label = _ref.label,
	    onCheck = _ref.onCheck;
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_Checkbox2.default, {
			labelStyle: labelStyle,
			style: style,
			checked: checked,
			disabled: disabled,
			label: label,
			onCheck: onCheck
		})
	);
};

exports.default = WMCheckbox;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMCheckbox/index.js